<template>
  <span>
    <VasionGeneralModal
      id="new-department-dialog"
      modalType="slot"
      :modalTitle="'New Department'"
      :sync="show"
      :hideButtons="false"
      :closeOnClickAway="false"
      :confirmButtonText="'Add'"
      :rejectButtonText="'Cancel'"
      :confirmButtonDisabled="departmentName.length === 0"
      showTopRightCloseButton
      @noButtonClick="close"
      @confirmButtonClick="addDepartment"
    >
      <div>
        <VasionInput
          v-model="departmentName"
          class="input-style department-name"
          inputType="top-white"
          :placeholder="'New Department'"
          :maxLengthProp="25"
          @input="errorLabelText = ''"
        />
        <label v-if="errorLabelText.length > 0" class="error-label">{{ errorLabelText }}</label>
      </div>
    </VasionGeneralModal>

    <VasionSnackbar
      :showSnackbarBool.sync="snackbar.show"
      :snackbarImage="snackbar.image"
      :snackbarSubTitle="snackbar.subtitle"
      :snackbarTitle="snackbar.title"
    />
  </span>
</template>

<script>
export default {
  name: 'AddDepartmentModal',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: function () {
    return {
      departmentName: '',
      errorLabelText: '',
      snackbar: {
        show: false,
        image: true,
        title: '',
        subtitle: ''
      }
    }
  },
  methods:{
    close(){
      this.departmentName = ''
      this.$emit('close')
    },
    showSnackbarSuccess(subtitle){
      this.snackbar = {
        title: 'Success',
        image: true,
        show: true,
        subtitle: subtitle
      }
    },
    async addDepartment(){
      const response = await this.$store.dispatch('security/addDepartment', { Value: this.departmentName })

      if (response?.Value?.length > 0 || response?.ResultStatus === 2) {
        this.errorLabelText = response.Value ?? 'Error saving department.'
        return
      }

      this.errorLabelText = ''
      this.showSnackbarSuccess(`'${this.departmentName}' added to departments`)

      await this.$store.dispatch('security/loadDepartmentList')
      this.$emit('departmentAdded', this.departmentName)
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.department-name {
  margin-top: 2rem;
  margin-bottom: 1rem;
  min-width: 350px;
}

.error-label {
  color: $error-red;
  font-weight: 200;
}
</style>
